(function(){
  function ready(fn){
    if(document.readyState!=='loading'){fn();}
    else{document.addEventListener('DOMContentLoaded',fn);}
  }
  ready(function(){
    var wsChecklistList=document.querySelector('[data-checklist-list]');
    if(!wsChecklistList)return;
    var wsTaskSheet=document.querySelector('[data-ws-task-sheet]');
    var wsTaskSheetBody=document.querySelector('[data-ws-task-sheet-body]');
    var wsTaskSheetBackdrop=document.querySelector('[data-ws-task-sheet-backdrop]');
    if(!wsTaskSheet||!wsTaskSheetBody||!wsTaskSheetBackdrop)return;
    var wsTaskSheetId=null;

    function esc(s){
      s=(s===undefined||s===null)?'':String(s);
      return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    function refreshTaskSelectLabel(id){
      /* label intentionally stays static "Select status" */
    }

    function renderTaskSheetMain(id){
      var realGroup=wsChecklistList.querySelector('[data-task-status-group="'+id+'"]');
      var activeBtn=realGroup?realGroup.querySelector('[data-task-status-btn].is-active'):null;
      var activeStatus=activeBtn?activeBtn.getAttribute('data-status'):'todo';
      var dueBtnReal=wsChecklistList.querySelector('[data-task-due-btn="'+id+'"]');
      var dueLbl=dueBtnReal?dueBtnReal.textContent.trim():'Due date';
      var opts=[['todo','Not started'],['in_progress','In progress'],['complete','Complete']];
      var html='<div class="atk-ws-task-sheet__label">Select status</div>';
      for(var i=0;i<opts.length;i++){
        html+='<button type="button" class="atk-ws-task-sheet__btn atk-ws-status-btn'+(activeStatus===opts[i][0]?' is-active':'')+'" data-status="'+opts[i][0]+'" data-sheet-status="'+opts[i][0]+'" data-sheet-task-id="'+esc(id)+'"><span class="atk-ws-status-btn__icon"></span>'+opts[i][1]+'</button>';
      }
      html+='<button type="button" class="atk-ws-task-sheet__btn" data-sheet-due="'+esc(id)+'" style="justify-content:center"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><rect x="3" y="4" width="18" height="18" rx="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>'+esc(dueLbl)+'</button>';
      wsTaskSheetBody.innerHTML=html;
    }

    function renderTaskSheetCalendar(id,viewDate){
      var realDueBtn=wsChecklistList.querySelector('[data-task-due-btn="'+id+'"]');
      if(realDueBtn)realDueBtn.click();
      var calSrc=wsChecklistList.querySelector('[data-task-cal="'+id+'"]');
      var html='<div class="atk-ws-task-sheet__label">Due date</div>';
      if(calSrc){
        html+=calSrc.innerHTML;
      }
      html+='<button type="button" class="atk-ws-task-sheet__btn" data-sheet-back="'+esc(id)+'">Back to status</button>';
      wsTaskSheetBody.innerHTML=html;
    }

    function openWsTaskSheet(id){
      wsTaskSheetId=id;
      renderTaskSheetMain(id);
      wsTaskSheetBackdrop.className='atk-ws-task-sheet-backdrop is-open';
      wsTaskSheet.className='atk-ws-task-sheet is-open';
      setTimeout(function(){wsTaskSheet.className='atk-ws-task-sheet is-open is-sheet-open';},10);
    }
    function closeWsTaskSheet(){
      wsTaskSheet.className='atk-ws-task-sheet is-open';
      wsTaskSheetBackdrop.className='atk-ws-task-sheet-backdrop';
      setTimeout(function(){wsTaskSheet.className='atk-ws-task-sheet';},280);
      wsTaskSheetId=null;
    }

    wsTaskSheetBackdrop.addEventListener('click',closeWsTaskSheet);

    wsChecklistList.addEventListener('click',function(e){
      var selectStatusBtn=e.target.closest('[data-task-select-status]');
      if(selectStatusBtn){
        e.stopPropagation();
        openWsTaskSheet(selectStatusBtn.getAttribute('data-task-select-status'));
      }
    });

    wsTaskSheetBody.addEventListener('click',function(e){
      var statusOpt=e.target.closest('[data-sheet-status]');
      if(statusOpt){
        var sid=statusOpt.getAttribute('data-sheet-task-id');
        var realGroup=wsChecklistList.querySelector('[data-task-status-group="'+sid+'"]');
        if(realGroup){
          var realBtns=realGroup.querySelectorAll('[data-task-status-btn]');
          for(var i=0;i<realBtns.length;i++){
            if(realBtns[i].getAttribute('data-status')===statusOpt.getAttribute('data-sheet-status')){
              realBtns[i].click();
            }
          }
        }
        refreshTaskSelectLabel(sid);
        closeWsTaskSheet();
        return;
      }
      var dueOpt=e.target.closest('[data-sheet-due]');
      if(dueOpt){
        renderTaskSheetCalendar(dueOpt.getAttribute('data-sheet-due'));
        return;
      }
      var backOpt=e.target.closest('[data-sheet-back]');
      if(backOpt){
        renderTaskSheetMain(backOpt.getAttribute('data-sheet-back'));
        return;
      }
      var calDayOpt=e.target.closest('[data-cal-day]');
      if(calDayOpt){
        var cid=wsTaskSheetId;
        var realDay=wsChecklistList.querySelector('[data-task-cal="'+cid+'"] [data-cal-day="'+calDayOpt.getAttribute('data-cal-day')+'"]');
        if(realDay)realDay.click();
        refreshTaskSelectLabel(cid);
        closeWsTaskSheet();
        return;
      }
      var navOpt=e.target.closest('[data-cal-nav]');
      if(navOpt){
        var nid=wsTaskSheetId;
        var realNav=wsChecklistList.querySelector('[data-task-cal="'+nid+'"] [data-cal-nav="'+navOpt.getAttribute('data-cal-nav')+'"]');
        if(realNav){
          realNav.click();
          setTimeout(function(){renderTaskSheetCalendar(nid);},10);
        }
        return;
      }
    });
  });
})();
